import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 700) {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= breakpoint,
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);

  return isMobile;
}
